<div class="tw-w-full">
  <app-page-template
    (clearQueryString)="onClearQueryString()"
    [showParent]="showParent"
    [config]="pageConfig"
    [bodyClass]="isShowInputs ? 'tw-p-1' : 'tw-pl-3 tw-pt-5'"
    (sortObject)="getSortItems($event)"
    (onShowAuditPage)="onShowPhonebookAudit.emit($event)"
    (onShowHelpPage)="onShowPhonebookHelp.emit($event)"
    (comparisonObjects)="getComparisonObjects($event)"
    (pageNumber)="changePageNumber($event)"
    (pageSize)="changePageSize($event)"
    (onAdd)="onCreate('', true)"
    (onSelectAll)="onSelectAll($event)"
    display="flex !important"
  >
    <!--*justCurrentOrganization-->
    <div title>
      <mat-checkbox
        class="tw-mx-2"
        [(ngModel)]="justCurrentOrganization"
        (ngModelChange)="getTableData()"
        (ngModelChange)="
          justCurrentOrganizationChange.emit(justCurrentOrganization)
        "
      >
        {{ "common.justCurrentOrganization" | translate }}
      </mat-checkbox>
    </div>
    <div class="card-toolbar" before-btns>
      <!-- !groupDeletion btn -->
      <button
        [matTooltip]="'common.groupDeletion' | translate"
        [disabled]="selectedPhonebooks?.length == 0"
        (click)="onGroupDeletion()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i class="mdi mdi-trash-can-outline mdi-20px tw-p-0 text-danger"></i>
      </button>
      <!-- * Advance Search btn -->
      <button
        [matTooltip]="'common.advanceSearch' | translate"
        (click)="onAdvanceSearch()"
        class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
        type="button"
        mat-ripple
      >
        <i
          *ngIf="!isShowAdvanceSearch"
          class="mdi mdi-magnify mdi-20px tw-p-0 text-primary"
        ></i>
        <i
          *ngIf="isShowAdvanceSearch"
          class="mdi mdi-arrow-left mdi-20px tw-p-0 text-primary"
        ></i>
      </button>
      
    </div>

    <!------------------------------------- Table Content ------------------------------------->
    <app-dynamic-table
      [class.tw-hidden]="isShowAdvanceSearch"
      custom-content
      [config]="pageConfig?.tableConfig"
      [loading]="pageConfig.loading"
      [isEmpty]="pageConfig?.isEmpty"
      [hasError]="pageConfig?.hasError"
      [showDoubleScroll]="false"
      (sortObject)="getSortItems($event)"
      (comparisonObjects)="getComparisonObjects($event)"
      (pageNumber)="changePageNumber($event)"
      (pageSize)="changePageSize($event)"
      (onSelectAll)="onSelectAll($event)"
    >
      <ng-container table-body *ngIf="items && !pageConfig.loading">
        <ng-container *ngFor="let item of items; let i = index">
          <!---------------------- level1 ---------------------->
          <tr
            [level]="1"
            class="tw-cursor-pointer"
            phonebook-row
            [ngClass]="{ 'row-active': item.id == selectedPhonebook.id }"
            [phonebook]="item"
            [isShowParentBtn]="isShowParentBtn"
            [checked]="item.checked || false"
            [phonebookRecipients]="phonebookRecipients"
            [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
            [isShowInputs]="isShowInputs"
            [isShowFullTable]="isShowFullTable"
            (operation)="onOperation($event, item)"
            (select)="onSelect($event)"
            (changeState)="onChangeState($event)"
          ></tr>
          @for (item2 of item?.subItems; track $index) {
          <!--* level 2 -->
          <tr
            *ngIf="item2?.isVisible"
            [level]="2"
            [paddingR]="15"
            class="tw-cursor-pointer"
            phonebook-row
            [ngClass]="{ 'row-active': item2.id == selectedPhonebook.id }"
            [phonebook]="item2"
            [isShowParentBtn]="isShowParentBtn"
            [checked]="item2.checked || false"
            [phonebookRecipients]="phonebookRecipients"
            [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
            [isShowInputs]="isShowInputs"
            [isShowFullTable]="isShowFullTable"
            (operation)="onOperation($event, item2)"
            (select)="onSelect($event)"
            (changeState)="onChangeState($event)"
          ></tr>
          @for (item3 of item2?.subItems; track $index) {
          <!--* level 3 -->
          <tr
            *ngIf="item3?.isVisible"
            [level]="3"
            [paddingR]="30"
            class="tw-cursor-pointer"
            phonebook-row
            [ngClass]="{ 'row-active': item3.id == selectedPhonebook.id }"
            [phonebook]="item3"
            [isShowParentBtn]="isShowParentBtn"
            [checked]="item3.checked || false"
            [phonebookRecipients]="phonebookRecipients"
            [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
            [isShowInputs]="isShowInputs"
            [isShowFullTable]="isShowFullTable"
            (operation)="onOperation($event, item3)"
            (select)="onSelect($event)"
            (changeState)="onChangeState($event)"
          ></tr>
          @for (item4 of item3?.subItems; track $index) {
          <!--* level 4 -->
          <tr
            *ngIf="item4?.isVisible"
            [level]="4"
            [paddingR]="45"
            class="tw-cursor-pointer"
            phonebook-row
            [ngClass]="{ 'row-active': item4.id == selectedPhonebook.id }"
            [phonebook]="item4"
            [isShowParentBtn]="isShowParentBtn"
            [checked]="item4.checked || false"
            [phonebookRecipients]="phonebookRecipients"
            [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
            [isShowInputs]="isShowInputs"
            [isShowFullTable]="isShowFullTable"
            (operation)="onOperation($event, item4)"
            (select)="onSelect($event)"
            (changeState)="onChangeState($event)"
          ></tr>
          @for (item5 of item4?.subItems; track $index) {
          <!--* level 5 -->
          <tr
            *ngIf="item5?.isVisible"
            [level]="5"
            [paddingR]="60"
            class="tw-cursor-pointer"
            phonebook-row
            [ngClass]="{
              'row-active': item5.id == selectedPhonebook.id
            }"
            [phonebook]="item5"
            [isShowParentBtn]="isShowParentBtn"
            [checked]="item5.checked || false"
            [phonebookRecipients]="phonebookRecipients"
            [PhonebookTypesEnumValues]="PhonebookTypesEnumValues"
            [isShowInputs]="isShowInputs"
            [isShowFullTable]="isShowFullTable"
            (operation)="onOperation($event, item5)"
            (select)="onSelect($event)"
            (changeState)="onChangeState($event)"
          ></tr>
          } } } }
        </ng-container>
      </ng-container>

      <!--  -->
      <ng-container
        table-body
        *ngIf="isWhiteMessagePhonebook && !privateNumber"
      >
        <tr>
          <td colspan="100">
            <p
              class="tw-dir-rtl ltr:tw-dir-ltr tw-text-[14px] tw-font-medium tw-my-5 tw-text-center text-danger"
            >
              {{ "messages.selectPrivateNumberForPhonebooks" | translate }}
            </p>
          </td>
        </tr>
      </ng-container>
    </app-dynamic-table>

    <ng-content select="[more-content]" custom-content></ng-content>
  </app-page-template>
</div>
